import { motion } from "framer-motion";
import { useTranslation } from "../hooks/useTranslation";

export default function About() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-secondary to-primary">
      <div className="section-padding">
        <div className="container-width">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              {t('about.title')}
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-accent to-accent-light mx-auto mb-8"></div>
          </motion.div>

          {/* Main Story */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-6xl mx-auto mb-16"
          >
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left: main story */}
              <div className="lg:col-span-2">
                <div className="card">
                  <h3 className="text-2xl font-bold text-accent mb-6">{t('about.heading')}</h3>
                  
                  <div className="space-y-4 text-muted-light leading-relaxed">
                    <p>{t('about.story.p1')}</p>
                    <p>{t('about.story.p2')}</p>
                    <p>{t('about.story.p3')}</p>
                    <p>{t('about.story.p4')}</p>
                    <p className="text-sm pt-4 border-t border-tertiary/20">
                      {t('about.story.p5')}
                    </p>
                  </div>
                </div>
              </div>

              {/* Right: Education & Timeline */}
              <motion.div
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.9 }}
                className="lg:col-span-1"
              >
                <div className="space-y-6 sticky top-24">
                  {/* Shizuoka Card */}
                  <div className="card bg-gradient-to-r from-blue-500/10 to-purple-500/10">
                    <h4 className="font-bold text-accent mb-3 flex items-center gap-2">
                      <span className="text-2xl">🇯🇵</span>
                      {t('about.education.shizuoka.university')}
                    </h4>
                    <p className="text-sm text-muted-light mb-2">
                      <strong className="text-white">{t('about.education.shizuoka.title')}</strong><br/>
                      {t('about.education.shizuoka.program')}
                    </p>
                    <div className="mt-3 pt-3 border-t border-accent/20">
                      <p className="text-xs text-muted">
                        {t('about.education.shizuoka.supervisor')}
                      </p>
                    </div>
                  </div>

                  {/* Completed Degree */}
                  <div className="card bg-gradient-to-r from-yellow-500/10 to-orange-500/10">
                    <h4 className="font-bold text-accent mb-2">{t('about.education.bachelor.title')}</h4>
                    <p className="text-xs text-muted-light">
                      {t('about.education.bachelor.university')}<br/>
                      {t('about.education.bachelor.detail')}<br/>
                      {t('about.education.bachelor.year')} • {t('about.education.bachelor.cgpa')}<br/>
                      {t('about.education.bachelor.distinction')}
                    </p>
                  </div>

                  {/* Interests */}
                  <div className="card bg-gradient-to-r from-green-500/10 to-emerald-500/10">
                    <h4 className="font-bold text-accent mb-3">{t('about.education.interests.title')}</h4>
                    <ul className="text-xs text-muted-light space-y-1">
                      {t('about.education.interests.list').map((interest: string, idx: number) => (
                        <li key={idx}>• {interest}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}